import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '~/services/api';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import {
  Container,
  QuickSelectCard,
  QuickSelectButtons,
  QuickSelectButton,
  CustomInputContainer,
  Table,
  TableHeader,
  TableBody,
  InputContainer,
} from './styles';
import InputText from '~/componentes/Inputs/InputText';
import { Colors } from '~/config/Colors';
import sistemaListStore, {
  sistemaListShowModal,
} from '~/pages/Sistema/componentes/SistemaList/ThisMainComponent/thisStore';

function GerenciarDiasAtrasos({ onClose, analistasOriginais = [] }) {
  const [loading, setLoading] = useState(true);
  const [customValue, setCustomValue] = useState('');
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [selectedQuickValue, setSelectedQuickValue] = useState(null);
  const [analistasData, setAnalistasData] = useState([]);
  // const [saving, setSaving] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const { dispatch } = React.useContext(sistemaListStore);

  const isDarkTheme = localStorage.getItem('tema') == 'E';

  // Função para filtrar analistas baseado na busca
  const filteredAnalistas = analistasData.filter(analista => {
    if (!searchTerm) return true;

    const searchLower = searchTerm.toLowerCase();
    return (
      analista.nome.toLowerCase().includes(searchLower) ||
      analista.codigo.toLowerCase().includes(searchLower)
    );
  });

  // Função para transformar dados da API no formato esperado
  const transformAnalistas = analistas => {
    return analistas.map(analista => ({
      id: analista.id,
      nome: analista.nome,
      codigo: analista.codigo,
      coordenador: analista.coordenador?.nome || 'Não informado',
      diasAtrasoAtual: analista.diasAtrasoOS || 0,
      novosDiasAtraso: analista.diasAtrasoOS || 0,
    }));
  };

  useEffect(() => {
    const loadAnalistas = async () => {
      setLoading(true);
      try {
        // Se foram passados analistas como prop, usa eles
        if (analistasOriginais && analistasOriginais.length > 0) {
          const analistasTransformados = transformAnalistas(analistasOriginais);
          setAnalistasData(analistasTransformados);
        } else {
          // Senão, busca da API
          const response = await api.get('/signed/empresa/gestorprojeto/gerencia/analistas', {
            params: { ativo: true },
          });
          const analistasTransformados = transformAnalistas(response.data || []);
          setAnalistasData(analistasTransformados);
        }
      } catch (error) {
        console.error('Erro ao carregar analistas:', error);
        // toast.error('Erro ao carregar a lista de analistas', {
        //   position: 'bottom-left',
        //   autoClose: 3000,
        //   style: {
        //     background: isDarkTheme ? '#2d2d2d' : '#fff',
        //     color: isDarkTheme ? '#fff' : '#333',
        //   },
        // });
      } finally {
        setLoading(false);
      }
    };

    loadAnalistas();
  }, [analistasOriginais, isDarkTheme]);

  const handleQuickSelect = value => {
    if (value === 'custom') {
      setShowCustomInput(true);
      setSelectedQuickValue('custom');
      return;
    }

    setShowCustomInput(false);
    setSelectedQuickValue(value);

    // Aplicar valor a todos os analistas (filtrados ou todos)
    const analistasParaAtualizar = searchTerm ? filteredAnalistas : analistasData;
    const idsParaAtualizar = analistasParaAtualizar.map(a => a.id);

    setAnalistasData(prev =>
      prev.map(analista =>
        idsParaAtualizar.includes(analista.id)
          ? { ...analista, novosDiasAtraso: parseInt(value) }
          : analista,
      ),
    );
  };

  const handleCustomValueSubmit = () => {
    if (!customValue || customValue <= 0) {
      // toast.error('Por favor, insira um valor válido maior que 0', {
      //   position: 'bottom-left',
      //   autoClose: 3000,
      //   style: {
      //     background: isDarkTheme ? '#2d2d2d' : '#fff',
      //     color: isDarkTheme ? '#fff' : '#333',
      //   },
      // });
      return;
    }

    const value = parseInt(customValue);

    // Aplicar valor customizado a todos os analistas (filtrados ou todos)
    const analistasParaAtualizar = searchTerm ? filteredAnalistas : analistasData;
    const idsParaAtualizar = analistasParaAtualizar.map(a => a.id);

    setAnalistasData(prev =>
      prev.map(analista =>
        idsParaAtualizar.includes(analista.id) ? { ...analista, novosDiasAtraso: value } : analista,
      ),
    );

    // const quantidadeAfetada = analistasParaAtualizar.length;
    // const mensagem = searchTerm
    //   ? `Valor ${value} aplicado a ${quantidadeAfetada} analista(s) filtrado(s)`
    //   : `Valor ${value} aplicado a todos os ${quantidadeAfetada} analistas`;

    // toast.success(mensagem, {
    //   position: 'bottom-left',
    //   autoClose: 3000,
    //   style: {
    //     background: isDarkTheme ? '#2d2d2d' : '#fff',
    //     color: isDarkTheme ? '#fff' : '#333',
    //   },
    // });
  };

  const handleIndividualChange = (analistaId, value) => {
    const numValue = parseInt(value) || 0;
    setAnalistasData(prev =>
      prev.map(analista =>
        analista.id === analistaId ? { ...analista, novosDiasAtraso: numValue } : analista,
      ),
    );
  };

  const handleSave = async () => {
    try {
      // Preparar dados para envio - apenas analistas que tiveram alteração
      const analistasAlterados = analistasData.filter(
        analista => analista.novosDiasAtraso !== analista.diasAtrasoAtual,
      );

      if (analistasAlterados.length === 0) {
        toast.info('Nenhuma alteração foi feita', {
          position: 'bottom-left',
          autoClose: 3000,
          style: {
            background: isDarkTheme ? '#2d2d2d' : '#fff',
            color: isDarkTheme ? '#fff' : '#333',
          },
        });
        return;
      }

      // Preparar dados para envio em lote
      const dadosParaEnvio = analistasAlterados.map(analista => ({
        id: analista.id,
        diasAtrasoOS: analista.novosDiasAtraso,
      }));

      return ShowConfirmacao(
        async () => {
          // setSaving(true);

          try {
            // Enviar todas as alterações em uma única requisição
            const response = await api.put(
              '/signed/empresa/gestorprojeto/gerencia/analista/dias-atraso-lote',
              {
                analistas: dadosParaEnvio,
              },
            );

            // Atualizar dados locais para refletir as mudanças salvas
            setAnalistasData(prev =>
              prev.map(analista => ({
                ...analista,
                diasAtrasoAtual: analista.novosDiasAtraso,
              })),
            );

            // Fechar modal se existe função de callback com delay
            if (onClose) {
              setTimeout(() => {
                onClose();
                dispatch(sistemaListShowModal(false));
              }, 2500); // 1 segundo de delay + tempo do toast de sucesso
            }

            return response;
          } catch (error) {
            console.error('Erro ao salvar configurações:', error);
            throw error;
          } finally {
            // setSaving(false);
          }
        },
        {
          errorModal: {
            defaultMessage: 'Erro ao salvar as configurações. Tente novamente.',
          },
          message: `Tem certeza que deseja atualizar os dias de atraso para ${analistasAlterados.length} analista(s)?`,
          successModal: `Configurações de dias de atraso atualizadas com sucesso para ${analistasAlterados.length} analista(s)!`,
        },
      );
    } catch (error) {
      console.error('Erro ao preparar dados para salvamento:', error);
      toast.error('Erro ao preparar os dados. Tente novamente.', {
        position: 'bottom-left',
        autoClose: 3000,
        style: {
          background: isDarkTheme ? '#2d2d2d' : '#fff',
          color: isDarkTheme ? '#fff' : '#333',
        },
      });
    }
  };

  return (
    <Container onSubmit={handleSave} defaultScroll={true} onClose={onClose}>
      <QuickSelectCard>
        <h4
          style={{
            margin: '0 0 16px 0',
            color: isDarkTheme ? '#fff' : '#6796cf',
            fontSize: '1rem',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <i className="material-icons" style={{ fontSize: '18px' }}>
            flash_on
          </i>
          Aplicar valor padrão a{' '}
          {searchTerm
            ? `${filteredAnalistas.length} analista(s) filtrado(s)`
            : 'todos os analistas'}
          :
        </h4>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '16px',
          }}
        >
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <InputText
              type="text"
              placeholder="Digite o nome ou código do analista..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{
                width: '100%',
                marginBottom: '0',
              }}
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm('')}
                style={{
                  position: 'absolute',
                  right: '12px',
                  background: 'transparent',
                  border: 'none',
                  color: isDarkTheme ? '#ffffff70' : '#00000070',
                  cursor: 'pointer',
                  fontSize: '18px',
                  padding: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                title="Limpar busca"
              >
                <i className="material-icons" style={{ fontSize: '18px' }}>
                  clear
                </i>
              </button>
            )}
          </div>

          <QuickSelectButtons>
            {[1, 2, 3, 4, 5].map(days => (
              <QuickSelectButton
                key={days}
                selected={selectedQuickValue === days}
                onClick={() => handleQuickSelect(days)}
                type="button"
              >
                {days} dia{days > 1 ? 's' : ''}
              </QuickSelectButton>
            ))}

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <QuickSelectButton
                type="button"
                selected={selectedQuickValue === 'custom'}
                onClick={() => {
                  if (selectedQuickValue === 'custom') {
                    setShowCustomInput(!showCustomInput);
                  } else {
                    handleQuickSelect('custom');
                  }
                }}
              >
                Custom
              </QuickSelectButton>

              {showCustomInput && (
                <CustomInputContainer>
                  <InputText
                    type="number"
                    placeholder="Digite o número de dias..."
                    value={customValue}
                    onChange={e => setCustomValue(e.target.value)}
                    min="1"
                    style={{ flex: 1 }}
                  />
                  <button
                    onClick={handleCustomValueSubmit}
                    style={{
                      padding: '8px 16px',
                      background: Colors.Input_Color_1,
                      border: 'none',
                      borderRadius: '8px',
                      color: Colors.text_Color_1,
                      cursor: 'pointer',
                      fontSize: '0.85rem',
                      fontWeight: '500',
                    }}
                    type="button"
                  >
                    Aplicar
                  </button>
                </CustomInputContainer>
              )}
            </div>
          </QuickSelectButtons>
        </div>
      </QuickSelectCard>

      <Table>
        <TableHeader>
          <div style={{ textAlign: 'left' }}>Nome do Analista</div>
          <div style={{ textAlign: 'left' }}>Coordenador</div>
          <div>Dias Atraso OS</div>
          <div>Novo Dias Atraso OS</div>
        </TableHeader>

        {loading ? (
          Array.from({ length: 5 }).map((_, idx) => (
            <TableBody key={idx} hasBorder>
              <div className="skeleton" style={{ height: 36, width: '80%' }} />
              <div className="skeleton" style={{ height: 36, width: '70%' }} />
              <div className="skeleton" style={{ height: 36, width: '100%' }} />
              <div
                className="skeleton"
                style={{ height: 36, width: '100%', borderRadius: '8px' }}
              />
            </TableBody>
          ))
        ) : filteredAnalistas.length > 0 ? (
          filteredAnalistas.map(analista => (
            <TableBody key={analista.id} hasBorder>
              <div>
                <div style={{ fontWeight: '500', textAlign: 'left', marginBottom: '2px' }}>
                  {analista.nome}
                </div>
                <div style={{ fontSize: '0.8rem', textAlign: 'left', opacity: 0.7 }}>
                  {analista.codigo}
                </div>
              </div>
              <div style={{ textAlign: 'left' }}>{analista.coordenador}</div>
              <div style={{ textAlign: 'center', fontWeight: '500' }}>
                {analista.diasAtrasoAtual}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <InputContainer>
                  <InputText
                    type="number"
                    value={analista.novosDiasAtraso}
                    onChange={e => handleIndividualChange(analista.id, e.target.value)}
                    min="0"
                    style={{ textAlign: 'center', maxWidth: '80px' }}
                  />
                </InputContainer>
              </div>
            </TableBody>
          ))
        ) : (
          <TableBody>
            <div
              style={{
                gridColumn: '1 / -1',
                textAlign: 'center',
                padding: '40px 20px',
                color: isDarkTheme ? '#ffffff70' : '#00000070',
                fontSize: '0.9rem',
              }}
            >
              {searchTerm
                ? `Nenhum analista encontrado para "${searchTerm}"`
                : 'Nenhum analista encontrado'}
            </div>
          </TableBody>
        )}
      </Table>

      <ToastContainer />
    </Container>
  );
}

export default GerenciarDiasAtrasos;
